import React from 'react';
import { Clock, ArrowRight } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function FinalCTA() {
  const handleBuyClick = e => {
    // Track AddToCart event
    trackAddToCart();
  };
  return <section className="py-16 px-4 md:px-8 lg:px-16 bg-gradient-to-r from-indigo-900 to-purple-900 text-white" data-id="element-56">
      <div className="max-w-5xl mx-auto text-center" data-id="element-57">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-58">
          Es Tu Momento De Transformar Tu Frecuencia Vibratoria
        </h2>
        <p className="text-xl mb-8 text-indigo-100 max-w-3xl mx-auto" data-id="element-59">
          Imagina cómo será tu vida cuando hayas elevado tu frecuencia a un
          nivel que nunca creíste posible. La claridad, la energía, la
          manifestación consciente... todo está a solo un paso.
        </p>
        <div className="bg-white/10 rounded-lg p-6 mb-10 inline-block" data-id="element-60">
          <div className="flex items-center justify-center" data-id="element-61">
            <Clock size={24} className="mr-2 text-yellow-400" data-id="element-62" />
            <span className="text-lg font-bold text-yellow-400" data-id="element-63">
              ¡OFERTA DISPONIBLE SOLO POR 24 HORAS!
            </span>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10" data-id="element-64">
          <a href="https://pay.hotmart.com/W101883420N" target="_blank" rel="noopener noreferrer" className="bg-yellow-500 hover:bg-yellow-400 text-indigo-900 font-bold py-4 px-8 rounded-lg text-lg flex items-center justify-center transition-all transform hover:scale-105 w-full sm:w-auto uppercase" onClick={handleBuyClick} data-id="element-65">
            Desclasificar Acceso Ahora
            <ArrowRight className="ml-2" size={20} data-id="element-66" />
          </a>
          <div className="text-indigo-100 text-center sm:text-left" data-id="element-67">
            <span className="block" data-id="element-68">Garantía de 7 días</span>
            <span className="font-bold" data-id="element-69">Sin riesgo para ti</span>
          </div>
        </div>
        <p className="text-indigo-200 italic" data-id="element-70">
          "El mayor arrepentimiento en la vida no es por lo que hicimos, sino
          por lo que no nos atrevimos a hacer."
        </p>
      </div>
    </section>;
}